import { useState, useEffect, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { photo, photoSrcSet } from '../assets/photos';
import Seo from '../components/Seo';

const PAGE_SIZE = 18;

const Gallery = () => {
  const [activeFilter,   setActiveFilter]   = useState('all');
  const [selectedImage,  setSelectedImage]  = useState<string | null>(null);
  const [selectedIndex,  setSelectedIndex]  = useState<number>(0);
  const [visibleCount,   setVisibleCount]   = useState(PAGE_SIZE);

  const handleFilterChange = (id: string) => {
    setActiveFilter(id);
    setVisibleCount(PAGE_SIZE);
  };

  const images = [
    // Alessandra & Gert
    { src: photo('alessandra-gert/1.jpg'), srcSet: photoSrcSet('alessandra-gert/1.jpg'),  category: 'weddings',    alt: 'Alessandra & Gert' },
    { src: photo('alessandra-gert/5.jpg'), srcSet: photoSrcSet('alessandra-gert/5.jpg'),  category: 'weddings',    alt: 'Alessandra & Gert' },
    { src: photo('alessandra-gert/10.jpg'), srcSet: photoSrcSet('alessandra-gert/10.jpg'), category: 'weddings',    alt: 'Alessandra & Gert' },
    { src: photo('alessandra-gert/15.jpg'), srcSet: photoSrcSet('alessandra-gert/15.jpg'), category: 'weddings',    alt: 'Alessandra & Gert' },
    { src: photo('alessandra-gert/20.jpg'), srcSet: photoSrcSet('alessandra-gert/20.jpg'), category: 'weddings',    alt: 'Alessandra & Gert' },
    // Amber & Erik
    { src: photo('amber-erik/1.jpg'), srcSet: photoSrcSet('amber-erik/1.jpg'),  category: 'weddings', alt: 'Amber & Erik' },
    { src: photo('amber-erik/5.jpg'), srcSet: photoSrcSet('amber-erik/5.jpg'),  category: 'weddings', alt: 'Amber & Erik' },
    { src: photo('amber-erik/10.jpg'), srcSet: photoSrcSet('amber-erik/10.jpg'), category: 'weddings', alt: 'Amber & Erik' },
    { src: photo('amber-erik/15.jpg'), srcSet: photoSrcSet('amber-erik/15.jpg'), category: 'weddings', alt: 'Amber & Erik' },
    { src: photo('amber-erik/20.jpg'), srcSet: photoSrcSet('amber-erik/20.jpg'), category: 'weddings', alt: 'Amber & Erik' },
    // Anné & Francois
    { src: photo('anne-francois/1.jpg'), srcSet: photoSrcSet('anne-francois/1.jpg'),  category: 'weddings', alt: 'Anné & Francois' },
    { src: photo('anne-francois/5.jpg'), srcSet: photoSrcSet('anne-francois/5.jpg'),  category: 'weddings', alt: 'Anné & Francois' },
    { src: photo('anne-francois/10.jpg'), srcSet: photoSrcSet('anne-francois/10.jpg'), category: 'weddings', alt: 'Anné & Francois' },
    { src: photo('anne-francois/15.jpg'), srcSet: photoSrcSet('anne-francois/15.jpg'), category: 'weddings', alt: 'Anné & Francois' },
    { src: photo('anne-francois/20.jpg'), srcSet: photoSrcSet('anne-francois/20.jpg'), category: 'weddings', alt: 'Anné & Francois' },
    // Carjone & Jacques
    { src: photo('carjone-jacques/1.jpg'), srcSet: photoSrcSet('carjone-jacques/1.jpg'),  category: 'weddings', alt: 'Carjone & Jacques' },
    { src: photo('carjone-jacques/5.jpg'), srcSet: photoSrcSet('carjone-jacques/5.jpg'),  category: 'weddings', alt: 'Carjone & Jacques' },
    { src: photo('carjone-jacques/10.jpg'), srcSet: photoSrcSet('carjone-jacques/10.jpg'), category: 'weddings', alt: 'Carjone & Jacques' },
    { src: photo('carjone-jacques/15.jpg'), srcSet: photoSrcSet('carjone-jacques/15.jpg'), category: 'weddings', alt: 'Carjone & Jacques' },
    { src: photo('carjone-jacques/20.jpg'), srcSet: photoSrcSet('carjone-jacques/20.jpg'), category: 'weddings', alt: 'Carjone & Jacques' },
    // Cezanne & Dewyk
    { src: photo('cezanne-dewyk/1.jpg'), srcSet: photoSrcSet('cezanne-dewyk/1.jpg'),  category: 'weddings', alt: 'Cezanne & Dewyk' },
    { src: photo('cezanne-dewyk/5.jpg'), srcSet: photoSrcSet('cezanne-dewyk/5.jpg'),  category: 'weddings', alt: 'Cezanne & Dewyk' },
    { src: photo('cezanne-dewyk/10.jpg'), srcSet: photoSrcSet('cezanne-dewyk/10.jpg'), category: 'weddings', alt: 'Cezanne & Dewyk' },
    { src: photo('cezanne-dewyk/15.jpg'), srcSet: photoSrcSet('cezanne-dewyk/15.jpg'), category: 'weddings', alt: 'Cezanne & Dewyk' },
    { src: photo('cezanne-dewyk/20.jpg'), srcSet: photoSrcSet('cezanne-dewyk/20.jpg'), category: 'weddings', alt: 'Cezanne & Dewyk' },
    // Dawn & Henko
    { src: photo('dawn-henko/1.jpg'), srcSet: photoSrcSet('dawn-henko/1.jpg'),  category: 'weddings', alt: 'Dawn & Henko' },
    { src: photo('dawn-henko/5.jpg'), srcSet: photoSrcSet('dawn-henko/5.jpg'),  category: 'weddings', alt: 'Dawn & Henko' },
    { src: photo('dawn-henko/10.jpg'), srcSet: photoSrcSet('dawn-henko/10.jpg'), category: 'weddings', alt: 'Dawn & Henko' },
    { src: photo('dawn-henko/15.jpg'), srcSet: photoSrcSet('dawn-henko/15.jpg'), category: 'weddings', alt: 'Dawn & Henko' },
    { src: photo('dawn-henko/20.jpg'), srcSet: photoSrcSet('dawn-henko/20.jpg'), category: 'weddings', alt: 'Dawn & Henko' },
    // Devon & Marnus
    { src: photo('devon-marnus/1.jpg'), srcSet: photoSrcSet('devon-marnus/1.jpg'),  category: 'weddings', alt: 'Devon & Marnus' },
    { src: photo('devon-marnus/5.jpg'), srcSet: photoSrcSet('devon-marnus/5.jpg'),  category: 'weddings', alt: 'Devon & Marnus' },
    { src: photo('devon-marnus/10.jpg'), srcSet: photoSrcSet('devon-marnus/10.jpg'), category: 'weddings', alt: 'Devon & Marnus' },
    { src: photo('devon-marnus/15.jpg'), srcSet: photoSrcSet('devon-marnus/15.jpg'), category: 'weddings', alt: 'Devon & Marnus' },
    { src: photo('devon-marnus/20.jpg'), srcSet: photoSrcSet('devon-marnus/20.jpg'), category: 'weddings', alt: 'Devon & Marnus' },
    // Jana & Dirk
    { src: photo('jana-dirk/1.jpg'), srcSet: photoSrcSet('jana-dirk/1.jpg'),  category: 'weddings', alt: 'Jana & Dirk' },
    { src: photo('jana-dirk/5.jpg'), srcSet: photoSrcSet('jana-dirk/5.jpg'),  category: 'weddings', alt: 'Jana & Dirk' },
    { src: photo('jana-dirk/10.jpg'), srcSet: photoSrcSet('jana-dirk/10.jpg'), category: 'weddings', alt: 'Jana & Dirk' },
    { src: photo('jana-dirk/15.jpg'), srcSet: photoSrcSet('jana-dirk/15.jpg'), category: 'weddings', alt: 'Jana & Dirk' },
    { src: photo('jana-dirk/20.jpg'), srcSet: photoSrcSet('jana-dirk/20.jpg'), category: 'weddings', alt: 'Jana & Dirk' },
    // Janelle & Gareth
    { src: photo('janelle-gareth/1.jpg'), srcSet: photoSrcSet('janelle-gareth/1.jpg'),  category: 'weddings', alt: 'Janelle & Gareth' },
    { src: photo('janelle-gareth/5.jpg'), srcSet: photoSrcSet('janelle-gareth/5.jpg'),  category: 'weddings', alt: 'Janelle & Gareth' },
    { src: photo('janelle-gareth/10.jpg'), srcSet: photoSrcSet('janelle-gareth/10.jpg'), category: 'weddings', alt: 'Janelle & Gareth' },
    { src: photo('janelle-gareth/15.jpg'), srcSet: photoSrcSet('janelle-gareth/15.jpg'), category: 'weddings', alt: 'Janelle & Gareth' },
    { src: photo('janelle-gareth/20.jpg'), srcSet: photoSrcSet('janelle-gareth/20.jpg'), category: 'weddings', alt: 'Janelle & Gareth' },
    // Janke & Deo
    { src: photo('janke-deo/1.jpg'), srcSet: photoSrcSet('janke-deo/1.jpg'),  category: 'weddings', alt: 'Janke & Deo' },
    { src: photo('janke-deo/5.jpg'), srcSet: photoSrcSet('janke-deo/5.jpg'),  category: 'weddings', alt: 'Janke & Deo' },
    { src: photo('janke-deo/10.jpg'), srcSet: photoSrcSet('janke-deo/10.jpg'), category: 'weddings', alt: 'Janke & Deo' },
    { src: photo('janke-deo/15.jpg'), srcSet: photoSrcSet('janke-deo/15.jpg'), category: 'weddings', alt: 'Janke & Deo' },
    { src: photo('janke-deo/20.jpg'), srcSet: photoSrcSet('janke-deo/20.jpg'), category: 'weddings', alt: 'Janke & Deo' },
    // Jordane & Riegal
    { src: photo('jordane-riegal/1.jpg'), srcSet: photoSrcSet('jordane-riegal/1.jpg'),  category: 'weddings', alt: 'Jordane & Riegal' },
    { src: photo('jordane-riegal/5.jpg'), srcSet: photoSrcSet('jordane-riegal/5.jpg'),  category: 'weddings', alt: 'Jordane & Riegal' },
    { src: photo('jordane-riegal/10.jpg'), srcSet: photoSrcSet('jordane-riegal/10.jpg'), category: 'weddings', alt: 'Jordane & Riegal' },
    { src: photo('jordane-riegal/15.jpg'), srcSet: photoSrcSet('jordane-riegal/15.jpg'), category: 'weddings', alt: 'Jordane & Riegal' },
    { src: photo('jordane-riegal/20.jpg'), srcSet: photoSrcSet('jordane-riegal/20.jpg'), category: 'weddings', alt: 'Jordane & Riegal' },
    // Kelsey & Armand
    { src: photo('kelsey-armand/1.jpg'), srcSet: photoSrcSet('kelsey-armand/1.jpg'),  category: 'weddings', alt: 'Kelsey & Armand' },
    { src: photo('kelsey-armand/5.jpg'), srcSet: photoSrcSet('kelsey-armand/5.jpg'),  category: 'weddings', alt: 'Kelsey & Armand' },
    { src: photo('kelsey-armand/10.jpg'), srcSet: photoSrcSet('kelsey-armand/10.jpg'), category: 'weddings', alt: 'Kelsey & Armand' },
    { src: photo('kelsey-armand/15.jpg'), srcSet: photoSrcSet('kelsey-armand/15.jpg'), category: 'weddings', alt: 'Kelsey & Armand' },
    { src: photo('kelsey-armand/20.jpg'), srcSet: photoSrcSet('kelsey-armand/20.jpg'), category: 'weddings', alt: 'Kelsey & Armand' },
    // Lauren & Jason
    { src: photo('lauren-jason/1.jpg'), srcSet: photoSrcSet('lauren-jason/1.jpg'),  category: 'weddings', alt: 'Lauren & Jason' },
    { src: photo('lauren-jason/5.jpg'), srcSet: photoSrcSet('lauren-jason/5.jpg'),  category: 'weddings', alt: 'Lauren & Jason' },
    { src: photo('lauren-jason/10.jpg'), srcSet: photoSrcSet('lauren-jason/10.jpg'), category: 'weddings', alt: 'Lauren & Jason' },
    { src: photo('lauren-jason/15.jpg'), srcSet: photoSrcSet('lauren-jason/15.jpg'), category: 'weddings', alt: 'Lauren & Jason' },
    { src: photo('lauren-jason/20.jpg'), srcSet: photoSrcSet('lauren-jason/20.jpg'), category: 'weddings', alt: 'Lauren & Jason' },
    // Lidia & Ruan
    { src: photo('lidia-ruan/1.jpg'), srcSet: photoSrcSet('lidia-ruan/1.jpg'),  category: 'weddings', alt: 'Lidia & Ruan' },
    { src: photo('lidia-ruan/5.jpg'), srcSet: photoSrcSet('lidia-ruan/5.jpg'),  category: 'weddings', alt: 'Lidia & Ruan' },
    { src: photo('lidia-ruan/10.jpg'), srcSet: photoSrcSet('lidia-ruan/10.jpg'), category: 'weddings', alt: 'Lidia & Ruan' },
    { src: photo('lidia-ruan/15.jpg'), srcSet: photoSrcSet('lidia-ruan/15.jpg'), category: 'weddings', alt: 'Lidia & Ruan' },
    { src: photo('lidia-ruan/20.jpg'), srcSet: photoSrcSet('lidia-ruan/20.jpg'), category: 'weddings', alt: 'Lidia & Ruan' },
    // Lisi & Bongani
    { src: photo('lisi-bongani/1.jpg'), srcSet: photoSrcSet('lisi-bongani/1.jpg'),  category: 'weddings', alt: 'Lisi & Bongani' },
    { src: photo('lisi-bongani/5.jpg'), srcSet: photoSrcSet('lisi-bongani/5.jpg'),  category: 'weddings', alt: 'Lisi & Bongani' },
    { src: photo('lisi-bongani/10.jpg'), srcSet: photoSrcSet('lisi-bongani/10.jpg'), category: 'weddings', alt: 'Lisi & Bongani' },
    { src: photo('lisi-bongani/15.jpg'), srcSet: photoSrcSet('lisi-bongani/15.jpg'), category: 'weddings', alt: 'Lisi & Bongani' },
    { src: photo('lisi-bongani/20.jpg'), srcSet: photoSrcSet('lisi-bongani/20.jpg'), category: 'weddings', alt: 'Lisi & Bongani' },
    // Mar-lize & Nefdt
    { src: photo('marlize-nefdt/1.jpg'), srcSet: photoSrcSet('marlize-nefdt/1.jpg'),  category: 'weddings', alt: 'Mar-lize & Nefdt' },
    { src: photo('marlize-nefdt/5.jpg'), srcSet: photoSrcSet('marlize-nefdt/5.jpg'),  category: 'weddings', alt: 'Mar-lize & Nefdt' },
    { src: photo('marlize-nefdt/10.jpg'), srcSet: photoSrcSet('marlize-nefdt/10.jpg'), category: 'weddings', alt: 'Mar-lize & Nefdt' },
    { src: photo('marlize-nefdt/15.jpg'), srcSet: photoSrcSet('marlize-nefdt/15.jpg'), category: 'weddings', alt: 'Mar-lize & Nefdt' },
    { src: photo('marlize-nefdt/20.jpg'), srcSet: photoSrcSet('marlize-nefdt/20.jpg'), category: 'weddings', alt: 'Mar-lize & Nefdt' },
    // Mel & Brandon
    { src: photo('mel-brandon/1.jpg'), srcSet: photoSrcSet('mel-brandon/1.jpg'),  category: 'weddings', alt: 'Mel & Brandon' },
    { src: photo('mel-brandon/5.jpg'), srcSet: photoSrcSet('mel-brandon/5.jpg'),  category: 'weddings', alt: 'Mel & Brandon' },
    { src: photo('mel-brandon/10.jpg'), srcSet: photoSrcSet('mel-brandon/10.jpg'), category: 'weddings', alt: 'Mel & Brandon' },
    { src: photo('mel-brandon/15.jpg'), srcSet: photoSrcSet('mel-brandon/15.jpg'), category: 'weddings', alt: 'Mel & Brandon' },
    { src: photo('mel-brandon/20.jpg'), srcSet: photoSrcSet('mel-brandon/20.jpg'), category: 'weddings', alt: 'Mel & Brandon' },
    // Michelle & ET
    { src: photo('michelle-et/venue-1.jpg'), srcSet: photoSrcSet('michelle-et/venue-1.jpg'),  category: 'weddings', alt: 'Michelle & ET' },
    { src: photo('michelle-et/venue-5.jpg'), srcSet: photoSrcSet('michelle-et/venue-5.jpg'),  category: 'weddings', alt: 'Michelle & ET' },
    { src: photo('michelle-et/bridal-1.jpg'), srcSet: photoSrcSet('michelle-et/bridal-1.jpg'), category: 'weddings', alt: 'Michelle & ET' },
    { src: photo('michelle-et/bridal-5.jpg'), srcSet: photoSrcSet('michelle-et/bridal-5.jpg'), category: 'weddings', alt: 'Michelle & ET' },
    { src: photo('michelle-et/couple-1.jpg'), srcSet: photoSrcSet('michelle-et/couple-1.jpg'), category: 'weddings', alt: 'Michelle & ET' },
    // Michelle & Trent
    { src: photo('michelle-trent/venue-1.jpg'), srcSet: photoSrcSet('michelle-trent/venue-1.jpg'),     category: 'weddings', alt: 'Michelle & Trent' },
    { src: photo('michelle-trent/bride-prep-1.jpg'), srcSet: photoSrcSet('michelle-trent/bride-prep-1.jpg'), category: 'weddings', alt: 'Michelle & Trent' },
    { src: photo('michelle-trent/ceremony-1.jpg'), srcSet: photoSrcSet('michelle-trent/ceremony-1.jpg'),  category: 'weddings', alt: 'Michelle & Trent' },
    { src: photo('michelle-trent/bridal-1.jpg'), srcSet: photoSrcSet('michelle-trent/bridal-1.jpg'),    category: 'weddings', alt: 'Michelle & Trent' },
    { src: photo('michelle-trent/couple-1.jpg'), srcSet: photoSrcSet('michelle-trent/couple-1.jpg'),    category: 'weddings', alt: 'Michelle & Trent' },
    // Mosa & Kudzai
    { src: photo('mosa-kudzai/1.jpg'), srcSet: photoSrcSet('mosa-kudzai/1.jpg'),  category: 'weddings', alt: 'Mosa & Kudzai' },
    { src: photo('mosa-kudzai/5.jpg'), srcSet: photoSrcSet('mosa-kudzai/5.jpg'),  category: 'weddings', alt: 'Mosa & Kudzai' },
    { src: photo('mosa-kudzai/10.jpg'), srcSet: photoSrcSet('mosa-kudzai/10.jpg'), category: 'weddings', alt: 'Mosa & Kudzai' },
    { src: photo('mosa-kudzai/15.jpg'), srcSet: photoSrcSet('mosa-kudzai/15.jpg'), category: 'weddings', alt: 'Mosa & Kudzai' },
    { src: photo('mosa-kudzai/20.jpg'), srcSet: photoSrcSet('mosa-kudzai/20.jpg'), category: 'weddings', alt: 'Mosa & Kudzai' },
    // Nadine & Mark
    { src: photo('nadine-mark/1.jpg'), srcSet: photoSrcSet('nadine-mark/1.jpg'),  category: 'weddings', alt: 'Nadine & Mark' },
    { src: photo('nadine-mark/5.jpg'), srcSet: photoSrcSet('nadine-mark/5.jpg'),  category: 'weddings', alt: 'Nadine & Mark' },
    { src: photo('nadine-mark/10.jpg'), srcSet: photoSrcSet('nadine-mark/10.jpg'), category: 'weddings', alt: 'Nadine & Mark' },
    { src: photo('nadine-mark/15.jpg'), srcSet: photoSrcSet('nadine-mark/15.jpg'), category: 'weddings', alt: 'Nadine & Mark' },
    { src: photo('nadine-mark/20.jpg'), srcSet: photoSrcSet('nadine-mark/20.jpg'), category: 'weddings', alt: 'Nadine & Mark' },
    // Nastasha & Lohan
    { src: photo('nastasha-lohan/1.jpg'), srcSet: photoSrcSet('nastasha-lohan/1.jpg'),  category: 'weddings', alt: 'Nastasha & Lohan' },
    { src: photo('nastasha-lohan/5.jpg'), srcSet: photoSrcSet('nastasha-lohan/5.jpg'),  category: 'weddings', alt: 'Nastasha & Lohan' },
    { src: photo('nastasha-lohan/10.jpg'), srcSet: photoSrcSet('nastasha-lohan/10.jpg'), category: 'weddings', alt: 'Nastasha & Lohan' },
    { src: photo('nastasha-lohan/15.jpg'), srcSet: photoSrcSet('nastasha-lohan/15.jpg'), category: 'weddings', alt: 'Nastasha & Lohan' },
    { src: photo('nastasha-lohan/20.jpg'), srcSet: photoSrcSet('nastasha-lohan/20.jpg'), category: 'weddings', alt: 'Nastasha & Lohan' },
    // Natasha & Jason
    { src: photo('natasha-jason/1.jpg'), srcSet: photoSrcSet('natasha-jason/1.jpg'),  category: 'weddings', alt: 'Natasha & Jason' },
    { src: photo('natasha-jason/5.jpg'), srcSet: photoSrcSet('natasha-jason/5.jpg'),  category: 'weddings', alt: 'Natasha & Jason' },
    { src: photo('natasha-jason/10.jpg'), srcSet: photoSrcSet('natasha-jason/10.jpg'), category: 'weddings', alt: 'Natasha & Jason' },
    { src: photo('natasha-jason/15.jpg'), srcSet: photoSrcSet('natasha-jason/15.jpg'), category: 'weddings', alt: 'Natasha & Jason' },
    { src: photo('natasha-jason/20.jpg'), srcSet: photoSrcSet('natasha-jason/20.jpg'), category: 'weddings', alt: 'Natasha & Jason' },
    // Nkateko & Fika
    { src: photo('nkateko-fika/1.jpg'), srcSet: photoSrcSet('nkateko-fika/1.jpg'),  category: 'weddings', alt: 'Nkateko & Fika' },
    { src: photo('nkateko-fika/5.jpg'), srcSet: photoSrcSet('nkateko-fika/5.jpg'),  category: 'weddings', alt: 'Nkateko & Fika' },
    { src: photo('nkateko-fika/10.jpg'), srcSet: photoSrcSet('nkateko-fika/10.jpg'), category: 'weddings', alt: 'Nkateko & Fika' },
    { src: photo('nkateko-fika/15.jpg'), srcSet: photoSrcSet('nkateko-fika/15.jpg'), category: 'weddings', alt: 'Nkateko & Fika' },
    { src: photo('nkateko-fika/20.jpg'), srcSet: photoSrcSet('nkateko-fika/20.jpg'), category: 'weddings', alt: 'Nkateko & Fika' },
    // Rain & Kevin
    { src: photo('rain-kevin/1.jpg'), srcSet: photoSrcSet('rain-kevin/1.jpg'),  category: 'weddings', alt: 'Rain & Kevin' },
    { src: photo('rain-kevin/5.jpg'), srcSet: photoSrcSet('rain-kevin/5.jpg'),  category: 'weddings', alt: 'Rain & Kevin' },
    { src: photo('rain-kevin/10.jpg'), srcSet: photoSrcSet('rain-kevin/10.jpg'), category: 'weddings', alt: 'Rain & Kevin' },
    { src: photo('rain-kevin/15.jpg'), srcSet: photoSrcSet('rain-kevin/15.jpg'), category: 'weddings', alt: 'Rain & Kevin' },
    { src: photo('rain-kevin/20.jpg'), srcSet: photoSrcSet('rain-kevin/20.jpg'), category: 'weddings', alt: 'Rain & Kevin' },
    // Sarah & Simon
    { src: photo('sarah-simon/venue-1.jpg'), srcSet: photoSrcSet('sarah-simon/venue-1.jpg'),     category: 'weddings', alt: 'Sarah & Simon' },
    { src: photo('sarah-simon/bride-prep-1.jpg'), srcSet: photoSrcSet('sarah-simon/bride-prep-1.jpg'), category: 'weddings', alt: 'Sarah & Simon' },
    { src: photo('sarah-simon/ceremony-1.jpg'), srcSet: photoSrcSet('sarah-simon/ceremony-1.jpg'),  category: 'weddings', alt: 'Sarah & Simon' },
    { src: photo('sarah-simon/bridal-1.jpg'), srcSet: photoSrcSet('sarah-simon/bridal-1.jpg'),    category: 'weddings', alt: 'Sarah & Simon' },
    { src: photo('sarah-simon/couple-1.jpg'), srcSet: photoSrcSet('sarah-simon/couple-1.jpg'),    category: 'weddings', alt: 'Sarah & Simon' },
    // Tamryn & Dean
    { src: photo('tamryn-dean/1.jpg'), srcSet: photoSrcSet('tamryn-dean/1.jpg'),  category: 'weddings', alt: 'Tamryn & Dean' },
    { src: photo('tamryn-dean/5.jpg'), srcSet: photoSrcSet('tamryn-dean/5.jpg'),  category: 'weddings', alt: 'Tamryn & Dean' },
    { src: photo('tamryn-dean/10.jpg'), srcSet: photoSrcSet('tamryn-dean/10.jpg'), category: 'weddings', alt: 'Tamryn & Dean' },
    { src: photo('tamryn-dean/15.jpg'), srcSet: photoSrcSet('tamryn-dean/15.jpg'), category: 'weddings', alt: 'Tamryn & Dean' },
    { src: photo('tamryn-dean/20.jpg'), srcSet: photoSrcSet('tamryn-dean/20.jpg'), category: 'weddings', alt: 'Tamryn & Dean' },
    // Timone & Wian
    { src: photo('timone-wian/1.jpg'), srcSet: photoSrcSet('timone-wian/1.jpg'),  category: 'weddings', alt: 'Timone & Wian' },
    { src: photo('timone-wian/5.jpg'), srcSet: photoSrcSet('timone-wian/5.jpg'),  category: 'weddings', alt: 'Timone & Wian' },
    { src: photo('timone-wian/10.jpg'), srcSet: photoSrcSet('timone-wian/10.jpg'), category: 'weddings', alt: 'Timone & Wian' },
    { src: photo('timone-wian/15.jpg'), srcSet: photoSrcSet('timone-wian/15.jpg'), category: 'weddings', alt: 'Timone & Wian' },
    { src: photo('timone-wian/20.jpg'), srcSet: photoSrcSet('timone-wian/20.jpg'), category: 'weddings', alt: 'Timone & Wian' },
    // Lebo & Siya — Engagement Session
    { src: photo('lebo-siya/1.jpg'), srcSet: photoSrcSet('lebo-siya/1.jpg'),  category: 'engagements', alt: 'Lebo & Siya' },
    { src: photo('lebo-siya/5.jpg'), srcSet: photoSrcSet('lebo-siya/5.jpg'),  category: 'engagements', alt: 'Lebo & Siya' },
    { src: photo('lebo-siya/10.jpg'), srcSet: photoSrcSet('lebo-siya/10.jpg'), category: 'engagements', alt: 'Lebo & Siya' },
    { src: photo('lebo-siya/15.jpg'), srcSet: photoSrcSet('lebo-siya/15.jpg'), category: 'engagements', alt: 'Lebo & Siya' },
    { src: photo('lebo-siya/20.jpg'), srcSet: photoSrcSet('lebo-siya/20.jpg'), category: 'engagements', alt: 'Lebo & Siya' },
    { src: photo('lebo-siya/25.jpg'), srcSet: photoSrcSet('lebo-siya/25.jpg'), category: 'engagements', alt: 'Lebo & Siya' },
    { src: photo('lebo-siya/30.jpg'), srcSet: photoSrcSet('lebo-siya/30.jpg'), category: 'engagements', alt: 'Lebo & Siya' },
    { src: photo('lebo-siya/35.jpg'), srcSet: photoSrcSet('lebo-siya/35.jpg'), category: 'engagements', alt: 'Lebo & Siya' },
  ];

  const filteredImages = activeFilter === 'all'
    ? images
    : images.filter(img => img.category === activeFilter);

  const visibleImages   = filteredImages.slice(0, visibleCount);
  const hasMore         = visibleCount < filteredImages.length;
  const remaining       = filteredImages.length - visibleCount;

  /* Lightbox keyboard nav */
  const navigate = useCallback((dir: 1 | -1) => {
    const next = selectedIndex + dir;
    if (next >= 0 && next < visibleImages.length) {
      setSelectedIndex(next);
      setSelectedImage(visibleImages[next].src);
    }
  }, [selectedIndex, visibleImages]);

  useEffect(() => {
    if (!selectedImage) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape')     { setSelectedImage(null); }
      if (e.key === 'ArrowRight') { navigate(1); }
      if (e.key === 'ArrowLeft')  { navigate(-1); }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [selectedImage, navigate]);

  const openLightbox = (src: string, idx: number) => {
    setSelectedImage(src);
    setSelectedIndex(idx);
  };

  const filters = [
    { id: 'all',         label: 'All Work' },
    { id: 'weddings',    label: 'Weddings' },
    { id: 'engagements', label: 'Engagements' },
  ];

  return (
    <div className="min-h-screen bg-ivory overflow-x-hidden">
      <Seo route="/gallery" />

      {/* ── Page header ─────────────────────────────────────────── */}
      <div className="page-header bg-ivory px-8 md:px-14 lg:px-20 max-w-screen-xl mx-auto">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.2 }}
          className="label-sm text-mist mb-5"
        >
          George &amp; Co.
        </motion.p>
        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.1, delay: 0.3, ease: [0.16, 1, 0.3, 1] }}
          className="heading-display text-ink text-[clamp(3rem,7vw,7rem)] mb-10"
        >
          The Archive
        </motion.h1>

        {/* Filters — text style */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.5 }}
          className="flex items-center gap-8 border-b border-silver/50 pb-6"
        >
          {filters.map(f => (
            <button
              key={f.id}
              onClick={() => handleFilterChange(f.id)}
              className={`label-sm pb-0.5 border-b transition-all duration-400 ${
                activeFilter === f.id
                  ? 'text-ink border-ink'
                  : 'text-mist border-transparent hover:text-ink/60'
              }`}
            >
              {f.label}
            </button>
          ))}
          <span className="label-sm text-mist ml-auto">{filteredImages.length} images</span>
        </motion.div>
      </div>

      {/* ── Editorial masonry grid ───────────────────────────────── */}
      <div className="max-w-screen-xl mx-auto px-8 md:px-14 lg:px-20 py-10 md:py-14">
        <AnimatePresence mode="wait">
          <motion.div
            key={activeFilter}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
            className="columns-1 sm:columns-2 lg:columns-3 gap-3"
          >
            {visibleImages.map((img, i) => (
              <motion.div
                key={img.src}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.7, delay: Math.min(i * 0.04, 0.5) }}
                className="break-inside-avoid mb-3 overflow-hidden group cursor-pointer relative"
                onClick={() => openLightbox(img.src, i)}
              >
                <img
                  src={img.src}
                  srcSet={img.srcSet}
                  sizes="(min-width: 1024px) 30vw, (min-width: 640px) 45vw, 100vw"
                  alt={`${img.alt} — ${img.category === 'engagements' ? 'engagement session' : 'wedding'} photography by George & Co.`}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-auto block group-hover:scale-[1.03] transition-transform duration-[1200ms] ease-out"
                />
                <div className="absolute inset-0 bg-ink/0 group-hover:bg-ink/15 transition-colors duration-500" />
              </motion.div>
            ))}
          </motion.div>
        </AnimatePresence>

        {/* Load more */}
        {hasMore && (
          <div className="flex flex-col items-center mt-16 gap-4">
            <button
              onClick={() => setVisibleCount(v => v + PAGE_SIZE)}
              className="flex items-center gap-4 border border-silver/60 text-ink px-10 py-4 label-sm hover:border-ink transition-colors duration-400"
            >
              Load more
              <span className="text-mist">({remaining} remaining)</span>
            </button>
            <div className="w-px h-8 bg-silver/40" />
          </div>
        )}
      </div>

      {/* ── Cinematic Lightbox ───────────────────────────────────── */}
      <AnimatePresence>
        {selectedImage && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.4 }}
            className="fixed inset-0 z-50 bg-ink/97 flex items-center justify-center"
            onClick={() => setSelectedImage(null)}
          >
            {/* Image */}
            <motion.img
              key={selectedImage}
              initial={{ opacity: 0, scale: 0.97 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
              src={selectedImage}
              alt={visibleImages[selectedIndex]?.alt ?? 'Gallery photo'}
              className="max-w-[88vw] max-h-[85vh] object-contain"
              onClick={e => e.stopPropagation()}
            />

            {/* Close */}
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute top-7 right-8 label-sm text-white/60 hover:text-white transition-colors duration-300"
            >
              Close
            </button>

            {/* Counter */}
            <div className="absolute bottom-7 left-1/2 -translate-x-1/2">
              <p className="label-sm text-white/60">
                {selectedIndex + 1} / {visibleImages.length}
              </p>
            </div>

            {/* Navigation */}
            {selectedIndex > 0 && (
              <button
                className="absolute left-6 top-1/2 -translate-y-1/2 label-sm text-white/60 hover:text-white transition-colors duration-300 p-3"
                onClick={e => { e.stopPropagation(); navigate(-1); }}
              >
                ←
              </button>
            )}
            {selectedIndex < visibleImages.length - 1 && (
              <button
                className="absolute right-6 top-1/2 -translate-y-1/2 label-sm text-white/60 hover:text-white transition-colors duration-300 p-3"
                onClick={e => { e.stopPropagation(); navigate(1); }}
              >
                →
              </button>
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Gallery;
